<template>
    <div class="login-pwd-reset">
        <form :id="'login-form-' + _uid" method="post">
            <div :class="{'modal-body': modalElement}">
                <div class="row">
                    <div class="col-12">
                        <div class="input-unit" data-validate="mail">
                            <input :placeholder="$translate('Ceres::Template.loginEmail')" type="email" name="email" autocomplete="email" :id="'email' + _uid" v-model="username" data-autofocus>
                        </div>
                        <span class="error-msg">{{ $translate("Ceres::Template.loginEnterConfirmEmail") }}</span>
                    </div>
                    <div class="col-12">
                        <div class="input-unit" :class="{'no-bottom': modalElement}" data-validate="text">
                            <input :placeholder="$translate('Ceres::Template.loginPassword')" type="password" name="password" autocomplete="current-password" :id="'password' + _uid" v-model="password">
                        </div>
                        <span class="error-msg">{{ $translate("Ceres::Template.loginEmptyPassword") }}</span>
                    </div>
                </div>
            </div>
            <div :class="{'modal-footer justify-content-center': modalElement, 'row': !modalElement}" class="mt-3">
                <div class="modal-footer-inner" :class="{'col-12': !modalElement}">
                    <slot name="extend-overlay-buttons"></slot>
                    <a href="javascript:void(0)" @click="showResetPwdView" class="small text-appearance login-pwd-reset__button">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"><g><g><path d="M9.43 4.714a4.716 4.716 0 0 1-9.43 0 4.716 4.716 0 0 1 9.43 0zM7.073 3.536c0-1.124-1.18-1.965-2.235-1.965-1 0-1.75.43-2.278 1.308a.193.193 0 0 0 .05.258l.81.614c.03.024.073.036.116.036a.195.195 0 0 0 .154-.073c.288-.369.411-.48.528-.565a.983.983 0 0 1 .528-.147c.393 0 .755.251.755.521 0 .32-.166.48-.54.651-.436.197-1.032.706-1.032 1.301v.221c0 .11.086.197.197.197h1.178c.11 0 .197-.086.197-.197 0-.14.178-.442.466-.607.467-.264 1.106-.62 1.106-1.553zM5.5 7.66V6.482a.194.194 0 0 0-.197-.196H4.126a.194.194 0 0 0-.197.196v1.179c0 .11.086.196.197.196h1.178c.11 0 .197-.086.197-.196z"/></g></g></svg>
                        {{ $translate("Ceres::Template.loginForgotPassword") }}?
                    </a>
                    <button @click.prevent="validateLogin" :disabled="isDisabled" class="login-btn btn btn-primary btn-appearance btn-medium text-uppercase d-block">
                        {{ $translate("Ceres::Template.login") }}
                        <icon icon="user" :loading="isDisabled"></icon>
                    </button>
                    <span class="login-or">-- {{ $translate("TuningFanatics::Template.or") }} --</span>
                    <a href="/register" :disabled="isDisabled" class="register-btn btn btn-primary btn-appearance btn-medium btn-primary--dark text-uppercase d-block">
                        {{ $translate("Ceres::Template.loginRegister") }}
                        <icon icon="user" :loading="isDisabled"></icon>
                    </a>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import { ButtonSizePropertyMixin } from "ceres/app/mixins/buttonSizeProperty.mixin";

    import ApiService from "ceres/app/services/ApiService";
    import NotificationService from "ceres/app/services/NotificationService";
    import ModalService from "ceres/app/services/ModalService";
    import AutoFocusService from "ceres/app/services/AutoFocusService";
    import ValidationService from "ceres/app/services/ValidationService";

    export default {
        mixins: [ButtonSizePropertyMixin],

        props: {
            backlink: {
                type: String
            },
            modalElement: {
                type: String
            },
            hasToForward:
                {
                    type: Boolean,
                    default: false
                }
        },

        data()
        {
            return {
                password: "",
                username: "",
                loginFields: [],
                isDisabled: false
            };
        },

        mounted()
        {
            this.$nextTick(() =>
            {
                this.loginFields = document.querySelector("#login-form-" + this._uid).querySelectorAll(".input-unit");

                AutoFocusService.triggerAutoFocus();
            });
        },

        watch:
            {
                password(val, oldVal)
                {
                    this.resetError();
                },

                username(val, oldVal)
                {
                    this.resetError();
                }
            },

        methods:
            {
                /**
                 * Open the login modal
                 */
                showLogin()
                {
                    ModalService.findModal(document.getElementById(this.modalElement)).show();
                },

                validateLogin()
                {
                    ValidationService.validate($("#login-form-" + this._uid))
                        .done(() =>
                        {
                            this.sendLogin();
                        })
                        .fail(invalidFields =>
                        {
                            ValidationService.markInvalidFields(invalidFields, "error");
                        });
                },

                /**
                 * Send the login data
                 */
                sendLogin()
                {
                    this.isDisabled = true;

                    ApiService.post("/rest/io/customer/login", { email: this.username, password: this.password }, { supressNotifications: true })
                        .done(response =>
                        {
                            ApiService.setToken(response);

                            NotificationService.success(
                                this.$translate("Ceres::Template.loginSuccessful")
                            ).closeAfter(10000);

                            if (this.backlink !== null && this.backlink)
                            {
                                location.assign(decodeURIComponent(this.backlink));
                            }
                            else if (this.hasToForward)
                            {
                                location.assign(location.origin);
                            }
                            else
                            {
                                location.reload();
                            }
                        })
                        .fail(response =>
                        {
                            this.isDisabled = false;

                            switch (response.error.code)
                            {
                                case 401:
                                    this.loginFields.forEach(element => element.classList.add("has-login-error"));

                                    let translationKey = "Ceres::Template.loginFailed";

                                    if (response.error.message.length > 0 && response.error.message === "user is blocked")
                                    {
                                        translationKey = "Ceres::Template.loginBlocked";
                                    }
                                    NotificationService.error(
                                        this.$translate(translationKey)
                                    ).closeAfter(10000);
                                    break;
                                default:
                                    return;
                            }
                        });
                },

                showResetPwdView()
                {
                    this.resetError();

                    this.$store.dispatch("loadComponent", "forgot-password-modal");

                    if (this.modalElement)
                    {
                        ModalService
                            .findModal(document.getElementById(this.modalElement))
                            .hide()
                            .then(() =>
                            {
                                ModalService.findModal(document.getElementById("resetPwd")).show();
                            });
                    }
                    else
                    {
                        ModalService.findModal(document.getElementById("resetPwd")).show();
                    }

                },

                resetError()
                {
                    this.loginFields.forEach( element => element.classList.remove("has-login-error"));
                    ValidationService.unmarkAllFields("#login-form-" + this._uid);
                }
            }
    }
</script>
